<template>
<v-card>
    <v-card-title class="d-flex justify-space-between flex-wrap">
        <div>
            Administración de Taquilla
        </div>
        <div>
            <v-btn color="primary" @click="add()"><v-icon>mdi-account-box</v-icon> Añadir taquilla</v-btn>
        </div>
    </v-card-title>
    <v-card-text>
        <TaquillaSearch v-model="params" @search="getList()"/>
    </v-card-text>
    <v-card-text>
        <v-card outlined>
            <v-data-table
                :headers="headersMod"
                :items="list"
                :options.sync="options"
                :server-items-length="count"
                :loading="loading"
                >
                <!-- eslint-disable-next-line -->
                <template v-slot:item.name="{ item }">
                    <div>
                        <v-chip label small :color="item.is_active ? 'primary' : 'secondary'">
                            <v-icon small v-if="item.is_active">mdi-check-circle-outline</v-icon>
                            <v-icon small v-else>mdi-cancel</v-icon>
                            <v-divider vertical class="mx-2"/>
                            {{ item.name }}
                        </v-chip>
                    </div>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.username="{ item }">
                    <div v-if="item">
                        <v-chip :color="item.is_active ? 'primary' : 'secondary'" label small>
                            <v-icon left small>mdi-account-circle-outline</v-icon>
                            {{ item.username }}
                        </v-chip>
                    </div>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.grupo.name="{ item }">
                    <div>
                        <v-chip label small>{{ item.grupo.id }} <v-divider vertical class="mx-2"/> {{ item.grupo.name }}</v-chip>
                    </div>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.devices="{ item }">
                    <div>
                        <v-btn class="mr-1" :color="item.is_bloqueado ? 'primary' : 'secondary'" @click="liberar(item)" :disabled="!item.is_bloqueado" x-small>
                            <v-icon small>mdi-desktop-tower-monitor</v-icon>
                            <v-divider vertical class="mx-2"/>
                            <template v-if="item.is_bloqueado">LIBERAR</template>
                            TAQUILLA
                            <template v-if="!item.is_bloqueado">LIBRE</template>
                        </v-btn>
                        <v-btn :color="item.is_mobile_bloqueado ? 'primary' : 'secondary'" @click="liberarMobile(item)" :disabled="!item.is_mobile_bloqueado" x-small>
                            <v-icon small>mdi-cellphone</v-icon>
                            <v-divider vertical class="mx-2"/>
                            <template v-if="item.is_mobile_bloqueado">LIBERAR</template>
                            MOBILE
                            <template v-if="!item.is_mobile_bloqueado">LIBRE</template>
                        </v-btn>
                    </div>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.actions="{ item }">
                    <div>
                        <v-btn icon @click="edit(item)">
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn color="primary" icon :to="{name: 'comercio.taquilla.view', params: {id: item.id}}">
                            <v-icon>mdi-eye</v-icon>
                        </v-btn>
                    </div>
                </template>
            </v-data-table>
        </v-card>
    </v-card-text>
    <TaquillaModal :open.sync="isModalOpen" @saved="postSaved" :taquilla="item"/>
</v-card>
</template>

<script>
import TaquillaService from '@services/comercio/TaquillaService';

import TaquillaSearch from '@components/entities/comercio/taquilla/search';
import TaquillaModal from '@components/entities/comercio/taquilla/modal';

export default {
    components: {
        TaquillaSearch,
        TaquillaModal
    },
    data: () => ({
        options: {},
        loading: false,
        list: [],
        count: 0,

        isModalOpen: false,
        item: null,

        params: {}
    }),
    created: function () {
        this.$store.dispatch('ui/layout/setTitle', 'Taquillas');
    },
    computed: {
        user: function () {
            return this.$store.getters['persist/auth/user'];
        },
        headersMod: function () {
            const headersA = [
                { text: 'Nombre', value: 'name' },
                { text: 'Usuario', value: 'username' },
            ];
            const headersB = [
                { text: 'Dispositivos', value: 'devices', align: 'center' },
                { text: 'Acciones', value: 'actions', align: 'right', width: 200 },
            ];
            return [
                ...headersA, 
                ['operadora'].includes(this.user.domain.slug) ? { text: 'Master', value: 'master.name' } : {},
                ['operadora', 'master'].includes(this.user.domain.slug) ? { text: 'Comercializadora', value: 'comercializadora.name' } : {},
                ['operadora', 'master', 'comercializadora', 'grupo'].includes(this.user.domain.slug) ? { text: 'Grupo', value: 'grupo.name' } : {},
                ...headersB
            ];
        },
    },
    methods: {
        getList: function (params = {}) {
            this.loading = true;
            this.list = [];
            TaquillaService.getList({...this.params, ...params, ... this.getOptions()})
                .then(({taquillaList, taquillaCount}) => {
                    this.list = taquillaList;
                    this.count = taquillaCount;
                }).finally(() => {
                    this.loading = false;
                });
        },
        add: function () {
            this.item = null;
            this.isModalOpen = true;
        },
        edit: function (item) {
            this.item = item;
            this.isModalOpen = true;
        },
        postSaved: function () {
            this.count = this.count + 1;
            this.getList();
        },
        getOptions: function () { 
            const params = {};
            let itemsPerPage = null;
            if (this.options.itemsPerPage !== -1) itemsPerPage = this.options.itemsPerPage
            else if (this.count) itemsPerPage = this.count
            params['limit'] = itemsPerPage;
            params['offset'] = (this.options.page * itemsPerPage) - itemsPerPage;
            return params;
        },
        liberar: function (item) {
            this.$ui.confirm({
                message: `¿Deseas liberar el usuario ${item.username}?`,
                textConfirm: 'Liberar',
                textCancel: 'Cancelar',
                confirm: () => {
                    this.liberarUsuario(item.id);
                },
            });
        },
        liberarUsuario: function (taquillaId) {
            this.loading = true;
            TaquillaService.liberar(taquillaId)
                .then(({taquilla}) => {
                    this.$emit('liberado', taquilla);
                    this.getList();
                    this.$ui.notificate({message: 'Usuario Liberado'});
                }).catch(() => {
                    this.$ui.notificate({message: 'Error liberando', color: 'error'});
                }).finally(() => {
                    this.loading = false;
                });
        },
        liberarMobile: function (item) {
            this.$ui.confirm({
                message: `¿Deseas liberar el usuario ${item.username} para la aplicación mobile?`,
                textConfirm: 'Liberar',
                textCancel: 'Cancelar',
                confirm: () => {
                    this.liberarUsuarioMobile(item.id);
                },
            });
        },
        liberarUsuarioMobile: function (taquillaId) {
            this.loading = true;
            TaquillaService.liberarMobile(taquillaId)
                .then(({taquilla}) => {
                    this.$emit('liberado', taquilla);
                    this.getList();
                    this.$ui.notificate({message: 'Usuario Liberado para la aplicación mobile'});
                }).catch(() => {
                    this.$ui.notificate({message: 'Error liberando', color: 'error'});
                }).finally(() => {
                    this.loading = false;
                });
        },
    },
    watch: {
        options: function () {
            this.getList();
        }
    }
}
</script>
